export const caseStudySpanishMetadata: Record<
  string,
  {
    title?: string;
    summary?: string;
    tags?: string[];
  }
> = {
  "deeptrait-ngs-data-analysis": {
    title: "Análisis NGS para el descubrimiento de fármacos",
    summary:
      "Cofundamos y construimos una plataforma de análisis NGS impulsada por IA que permite a científicos de laboratorio descubrir nuevas dianas terapéuticas y marcadores diagnósticos en menos de seis horas, sin necesidad de código, scripts ni línea de comandos.",
    tags: ["Desarrollo de IA", "Bioinformática", "Pharma y salud"],
  },
  "astrazeneca-medical-affairs-ai": {
    title: "Producto de IA para Medical Affairs",
    summary:
      "Desarrollamos una herramienta analítica basada en IA y un pipeline de Medical Affairs para una farmacéutica global, automatizando el análisis de registros CRM para obtener hallazgos accionables a gran escala.",
    tags: ["Desarrollo de IA", "IA generativa", "Pharma y salud"],
  },
  "civitta-ai-accelerator-consulting": {
    title: "Arquitectura de IA para startups de IA generativa",
    summary:
      "Ofrecimos asesoría tecnológica de IA para cuatro startups del Challenger AI Accelerator, desarrollando estrategias completas de producto de IA y planes de implementación accionables con diseños de arquitectura de sistemas.",
    tags: ["Estrategia de IA", "Consultoría", "IA generativa"],
  },
  "xfusion-rag-chatbot": {
    title: "Chatbot RAG para plataforma de datos empresarial",
    summary:
      "Diseñamos un sistema avanzado de Retrieval-Augmented Generation (RAG) para la plataforma xAQUA® de xFusion, permitiendo consultas en lenguaje natural sobre repositorios documentales empresariales.",
    tags: ["Desarrollo de IA", "RAG", "Enterprise y sector público"],
  },
  "periodix-lead-generation-ai": {
    title: "Asistente IA para generación de leads",
    summary:
      "Desarrollamos un chatbot comercial generativo personalizado basado en un modelo Llama-2 ajustado, desplegado como componente cloud listo para producción para generación de leads.",
    tags: ["Desarrollo de IA", "IA generativa", "Fine-tuning de LLM", "Ventas y marketing"],
  },
  "dynamiq-genai-platform-strategy": {
    title: "Estrategia de IA generativa para plataforma de IA",
    summary:
      "Diseñamos una estrategia completa de IA generativa que incluye análisis de mercado, fine-tuning de LLM e integración RAG para una plataforma líder de IA generativa.",
    tags: ["Estrategia de IA", "IA generativa", "Fine-tuning de LLM", "Enterprise y sector público"],
  },
  "axbio-questionnaire-analysis": {
    title: "Análisis de cuestionarios de salud con IA",
    summary:
      "Construimos una plataforma cloud de extremo a extremo que recoge respuestas a cuestionarios de salud, aplica scoring ponderado y utiliza Azure OpenAI para generar informes personalizados enviados automáticamente por correo electrónico.",
    tags: ["Desarrollo de IA", "IA generativa", "Pharma y salud"],
  },
  "pumb-retail-banking-ai-strategy": {
    title: "Estrategia de IA para banca minorista",
    summary:
      "Diseñamos una estrategia integral de IA para un gran banco minorista, incluyendo análisis competitivo, recomendaciones de modelos de IA y una hoja de ruta de transformación tecnológica.",
    tags: ["Estrategia de IA", "Banca y finanzas"],
  },
  "bank-rag-chatbot": {
    title: "Chatbot RAG para un gran banco canadiense",
    summary:
      "Construimos un sistema de Retrieval-Augmented Generation (RAG) listo para producción que permite responder preguntas de forma inteligente sobre más de 3.200 documentos internos usando Azure OpenAI y LangChain.",
    tags: ["Desarrollo de IA", "RAG", "IA generativa", "Banca y finanzas"],
  },
};
